module.exports = __webpack_public_path__ + "img/2_154.a4f61ad1.png";